import { combineReducers } from 'redux';
import userDetail from "./userDetail";
import auth from "./auth.js";

export default combineReducers({
    userDetail,
    auth
});